import { Component, OnInit, Input } from '@angular/core';
import { FormUtils } from 'src/app/shared/utils/form-utils';
import { FormBuilder, FormGroup, Validators, FormControl, FormArray } from '@angular/forms';
import { trigger, state, style, transition, animate } from '@angular/animations';
import { CatalogoService } from 'src/app/services/catalogo.service';
import { SelectItem } from 'primeng/api';

@Component({
  selector: 'creador-catalogo',
  templateUrl: './creador-catalogo.component.html',
  styleUrls: ['./creador-catalogo.component.scss'],

})
export class CreadorCatalogoComponent implements OnInit {
  public form: FormGroup;
  public tiposDatosSeleccionados: any[] = [
  ];
  public tiposDatos: SelectItem[] = [
    { label: 'string', value: 'string' },
    { label: 'number', value: 'number' },
    { label: 'boolean', value: 'boolean' }
  ]
  public tiposDatosBooleanos: SelectItem[] = [
    { label: 'true', value: true },
    { label: 'false', value: false }
  ];

  constructor(
    public formUtils: FormUtils,
    private formBuilder: FormBuilder,
    private catalogoService: CatalogoService
  ) { }

  public ngOnInit(): void {
    this.inicializarForm();
  }

  public inicializarForm(): void {
    this.form = this.formBuilder.group({
      identificador: new FormControl('', [Validators.required]),
      nombre: new FormControl(null, [Validators.required]),
      campos: this.formBuilder.array([]),
    });
    this.agregarCampo();
  }

  public crearFormCampo(): FormGroup {
    return this.formBuilder.group({
      identificadorCampo: new FormControl('', [Validators.required]),
      valor: new FormControl('', [Validators.required]),
    });
  }

  public agregarCampo(): void {
    this.tiposDatosSeleccionados.push('string');
    (this.form.get('campos') as FormArray).push(this.crearFormCampo());
  }

  public eliminarCampo(indice: number): void {
    this.tiposDatosSeleccionados.splice(indice, 1);
    (<FormArray>this.form.controls.campos).removeAt(indice);
  }

  onChange(event: any, indice: number) {
    if (event.value === 'boolean') {
      (this.form.get('campos') as FormArray).at(indice).get('valor').setValue(true);
    }
  }

  public crearCatalogo() {
  }

}
